/**
 * Jobs already booked for someone on the days they were just marked out
 * (lifecycle audit, 10/29) — the shape POST /dispatch/out-days returns as
 * `bookedJobs`, and the one line that sums them up.
 */
export interface BookedJobOnOutDay {
    jobId: string;
    jobNumber: string | null;
    title: string | null;
    customerName: string | null;
    siteName: string | null;
    day: string;
    scheduledStart: string;
    role: "lead" | "helper";
}

export function bookedJobsLine(jobs: readonly BookedJobOnOutDay[]): string {
    const n = jobs.length;
    if (n === 0) return "No jobs are booked for them on those days.";
    const days = new Set(jobs.map((j) => j.day)).size;
    return `${n} ${n === 1 ? "job is" : "jobs are"} still booked for them on ${days === 1 ? "that day" : `${days} of those days`}. Move ${n === 1 ? "it" : "them"} so nothing is missed.`;
}
